<template>
  <div
    class="bg-teal-lighter text-grays-darkest relative top-0 flex w-full items-center justify-center px-4 py-4 text-sm sm:py-2.5"
  >
    <span class="text-center sm:text-left">
      <span class="font-semibold">Special Offer: </span>
      <span v-if="discountOnly"
        >{{ currentGift?.discountPercentage }}% off all eyewear & lenses at
        checkout</span
      >
      <span v-else
        >Spend ${{ currentGift?.orderMinimum }} on eyewear & lenses, get
        {{ currentGift?.discountPercentage }}% off at checkout</span
      >
    </span>
    <button
      class="right-5 ml-auto pl-4 sm:absolute sm:pl-0"
      @click="dismissBanner()"
    >
      <ZenniIconsIconClose />
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, storeToRefs } from '#imports'
import { useOnboardStore } from '~/store/onboard'
import { useGuestStore } from '~/store/guest'

const { currentGift } = storeToRefs(useGuestStore())
const discountOnly = computed<boolean>(() =>
  Boolean(
    currentGift.value?.discountPercentage && !currentGift.value?.orderMinimum,
  ),
)

const onboardStore = useOnboardStore()
const dismissBanner = () => {
  onboardStore.setDiscountBannerDismissed(true)
}
</script>
